import React from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { ApolloError, useMutation } from '@apollo/client';

import SignFormsContainer from 'components/forms/styled/SignFormsContainer';
import { withFlashMessages } from 'components/FlashMessages/index';
import { Dispatch } from 'types';
import { ForgottenPasswordRequestFormFields } from 'components/forms/ForgottenPasswordRequestForm/types';
import { useTranslation } from 'lib/i18n';
import {
  CreateResetPasswordRequestMutation,
  CreateResetPasswordRequestMutationVariables,
} from 'types/graphql';

import CREATE_RESET_PASSWORD_REQUEST_MUTATION from './mutations/createResetPasswordRequest';
import { FORM_ID } from './constants';
import Form from './composeForm';
import {
  ForgottenPasswordRequestFormProps,
  ForgottenPasswordRequestFormPropsMapDispatch,
} from './types';

const ForgottenPasswordRequestForm: React.FC<ForgottenPasswordRequestFormProps> =
  props => {
    const { t, i18n } = useTranslation('forms');
    const [mutate] = useMutation<
      CreateResetPasswordRequestMutation,
      CreateResetPasswordRequestMutationVariables
    >(CREATE_RESET_PASSWORD_REQUEST_MUTATION);
    const handleCompleted = (): void => {
      props.resetForm();
      props.showFlashMessage(t('forgottenPasswordRequestForm.success'), {
        type: 'success',
      });
    };

    const handleError = (error: ApolloError): ApolloError => {
      const message =
        Array.isArray(error) && error[0].type
          ? t(`forgottenPasswordRequestForm.error.${error[0].type}`)
          : error.message;

      props.showFlashMessage(message, { type: 'danger' });

      return error;
    };

    const handleRequest = (
      variables: ForgottenPasswordRequestFormFields,
    ): Promise<void | ApolloError> =>
      mutate({ variables }).then(handleCompleted).catch(handleError);

    return (
      <SignFormsContainer>
        {/* I do not have suicidal tendencies so I am not gonna fix it */}
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <Form id={FORM_ID} i18n={i18n} t={t} onSubmit={handleRequest} />
      </SignFormsContainer>
    );
  };

const mapDispatchToProps = (
  dispatch: Dispatch,
): ForgottenPasswordRequestFormPropsMapDispatch => ({
  resetForm: () => dispatch(reset(FORM_ID)),
});

export default withFlashMessages(
  connect(null, mapDispatchToProps)(ForgottenPasswordRequestForm),
);
